// =============================================================================
// VandieZ admin-web -- <ProtectedRoute>
// =============================================================================
// Renders children only if there's an authenticated session. Otherwise it
// redirects to /login, preserving the original target via location.state
// so the login page can send the user back where they were trying to go.
//
// During initial rehydration (auth context still calling /auth/me) we
// render a neutral splash so the user doesn't see a flash of the login
// page before being immediately bounced back to their original route.
// =============================================================================

import type React from "react";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/lib/auth";

export function ProtectedRoute({ children }: { children: ReactNode }): React.JSX.Element {
  const { user, isInitializing } = useAuth();
  const location = useLocation();

  if (isInitializing) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    );
  }

  if (user === null) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
